import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'CouchCafeApp';

  constructor(){}

  ngOnInit() {
    window.addEventListener('mousemove', (e) => {
      const payload = {
        type: 'mouseMove',
        position: { x: e.clientX, y: e.clientY }
      };

      window.parent.postMessage(payload, '*'); // Use exact origin
    });

    window.addEventListener('wheel', (e) => {
      const payload = {
        type: 'scroll',
        deltaY: e.deltaY
      }
      window.parent.postMessage(payload, '*');
    });
  }
}
